import { FocusingEffects } from './focusing-inputs.effects';
import { CommentingPanelEffects } from './commenting-panel/commenting-panel.effects';

export const effects = [FocusingEffects, CommentingPanelEffects];
